<template>
  <div style="display: flex;justify-content: center;">
    <div style="width:90%; display:flex;justify-content: center;flex-direction: column;">
      <div style="display: flex;justify-content: center;margin-top: 20px;font-size: 22px;">多人填表Web端</div>
      <div style="border-color: #cbcbcb;border-style: solid;border-width: thin;margin: 20px;">

        <div style="margin: 50px;">
          <div style="text-align: center;margin-top: 20px;font-size: 18px;">{{form_name}}</div>
          <div style="text-align: center;margin-top: 10px;font-size: 10px;">ID:{{form_id}}</div>
          <div style="text-align: center;margin-top: 20px;font-size: 14px;">{{form_comment}}</div>
          <div v-for="(field,index) in formFields" :key="field.id" style="margin: 20px;">
            <span style="font-size: 18px;">
              <span v-if="field.optional!==1" style="color:red;font-size: 30px;vertical-align:middle;">*</span>
              {{index+1}}.{{field.field_name}}</span>
            <div style="margin-bottom: 10px;"><span
                style="text-decoration: underline;margin-top: 5px;font-weight: normal;font-size: 12px;"
                @click="showFieldComment(field.field_name,index)"
                v-if="showComment(field.field_comment)">(查看填写说明)</span>
            </div>
            <div v-if="field.field_type==='文本'">
              <el-input type="textarea" :rows="2" v-model="fieldValues[index]" placeholder="请输入内容"></el-input>
            </div>

            <div v-if="field.field_type==='数字'">
              <el-input v-model="fieldValues[index]" placeholder="请输入内容"></el-input>
            </div>

            <div v-if="field.field_type==='日期'">
              <el-date-picker v-model="fieldValues[index]" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </div>

            <div v-if="field.field_type==='日期时间'">
              <el-date-picker v-model="fieldValues[index]" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>

            <div v-if="field.field_type==='自动时间'">
              <el-input v-model="fieldValues[index]" :disabled="true">
              </el-input>
            </div>

            <div v-if="field.field_type==='图片'">
              <!--            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> -->

              <div style="color:red;text-decoration: underline;" @click="openQrcode">电脑端不支持,请在手机端操作,点我打开二维码扫码领表</div>
            </div>

            <div v-if="field.field_type==='视频'">
              <div style="color:red;text-decoration: underline;" @click="openQrcode">电脑端不支持,请在手机端操作,点我打开二维码扫码领表</div>
            </div>

            <div v-if="field.field_type==='签名'">
              <div style="color:red;text-decoration: underline;" @click="openQrcode">电脑端不支持,请在手机端操作,点我打开二维码扫码领表</div>
            </div>

            <div v-if="field.field_type==='单选'">
              <el-radio-group v-model="fieldValues[index]">
                <div style="margin-bottom: 10px;" v-for="(option,index) in loadSingleOptions(field.field_name)"
                  :key="index">
                  <el-radio :label="option">{{option}}</el-radio>
                </div>
              </el-radio-group>
            </div>

            <div v-if="field.field_type==='多选'">
              <el-checkbox-group v-model="fieldValues[index]">
                <el-checkbox :label="option.label" v-for="(option) in loadMutiOptions(field.field_name)"
                  :key="option.label" style="display: block; padding-top: 10px;">
                  {{option.label}}
                </el-checkbox>
              </el-checkbox-group>

            </div>

            <div v-if="field.field_type==='条形码'">
              <div style="color:red;text-decoration: underline;" @click="openQrcode">电脑端不支持,请在手机端操作,点我打开二维码扫码领表</div>
            </div>

            <div v-if="field.field_type==='二维码'">
              <div style="color:red;text-decoration: underline;" @click="openQrcode">电脑端不支持,请在手机端操作,点我打开二维码扫码领表</div>
            </div>

            <div v-if="field.field_type==='身份证号'">
              <el-input v-model="fieldValues[index]" placeholder="请输入内容"></el-input>
            </div>

            <div v-if="field.field_type==='手机号'">
              <el-input v-model="fieldValues[index]" placeholder="请输入内容"></el-input>
            </div>

            <div v-if="field.field_type==='Email邮箱'">
              <el-input v-model="fieldValues[index]" placeholder="请输入内容"></el-input>
            </div>

            <div v-if="field.field_type==='车牌号'">
              <el-input v-model="fieldValues[index]" placeholder="请输入内容"></el-input>
            </div>

          </div>
        </div>

        <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <el-button type="primary" plain @click="saveFormData">提交表格</el-button>
        </div>
      </div>

      <div style="display: flex;justify-content: center;flex-direction: column;">
        <div style="display: flex;justify-content: center;font-size: 14px;color:red;margin-bottom: 10px;">多人填表用多人填表
        </div>
        <div style="display: flex;justify-content: center;">本填表工具由多人填表小程序提供</div>
      </div>

    </div>

    <!--显示二维码-->
    <el-dialog width="40%" :close-on-click-modal="false" title="扫码领表填表" :visible.sync="scanQrcodeDialogVisible">
      <div style="text-align: center;">
        微信扫码下面的二维码领取表格填写
      </div>
      <div style="text-align: center;">
        <img :src="qrcode_image_url" style="width:300px;height: 300px;"/>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="scanQrcodeDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Utils from '../utils/utils.js'

  export default {
    components: {},
    created() {
      this.form_id = this.$route.query.form_id
      // console.log(this.$route.query)
      // this.form_id = 20980
      this.loadForm()
    },
    data() {
      return {
        form_id: '',
        formFields: [],
        form_name: [],
        fieldValues: [],
        fieldComments: [],
        remaid_minute: '',
        field_optionals: '',
        mutiSelectShow: '',
        form_comment: '',
        field_samples: [],
        field_options: [],

        mutiSelect: [],

        scanQrcodeDialogVisible: false,
        qrcode_image_url: ''
      }
    },
    methods: {
      loadForm() {
        let that = this
        var requestUrl = '/form/web/_load_user_form.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(response) {
            that.formFields = response.data.formFields
            that.form_name = response.data.formName

            if (that.user_action === 'add_record') {
              that.fieldValues = []
            } else {
              that.fieldValues = response.data.fieldValues
            }

            that.fieldComments = response.data.formComments

            // that.fieldValues = res.data.fieldValues
            that.remaid_minute = response.data.remaid_minute

            that.field_optionals = response.data.field_optionals
            // console.log('optionals', that.field_optionals)

            that.clearAllData()

            that.form_comment = response.data.comment
            if (typeof (that.form_comment) !== 'undefined' && that.form_comment.length > 0) {
              that.hiddenCommentTipDialog = false
            } else {
              that.hiddenCommentTipDialog = true
            }

            that.field_samples = response.data.field_samples

            that.field_options = response.data.field_options

            // that.form_id = res.data.form_id

            // that.initImageData()
            // that.initVideoData()
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      showFieldComment(field_name, index) {
        let comment = this.fieldComments[index].value
        this.$message(comment)
      },
      showComment(field_comment) {

      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      },
      saveFormData() {
        if (!this.formDataIsValid()) {
          return
        }

        console.log('数据合法，准备保存！')

        var equipment_id = Utils.getEquipmentID()

        var values_json = JSON.stringify(this.fieldValues)

        let that = this

        var requestUrl = '/form/web/_user_save_form_data.jsp'
        // 开启loading

        let data = {
          equipment_id: equipment_id,
          form_id: that.form_id,
          values_json: values_json
        }

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在保存,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            if (response.data.result === '1') {
              that.$message.success('保存成功！')
              // 清空数据
              that.clearAllData()
            } else {

            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      clearAllData() {
        let that = this
        that.fieldValues = []
        if (that.fieldValues.length === 0) {
          // 初始化数据
          for (var i = 0; i < that.formFields.length; i++) {
            if (that.formFields[i].field_type === '自动时间') {
              var currentTime = Utils.getCurrentDateTime()
              that.fieldValues.push(currentTime)
            } else if (that.formFields[i].field_type === '多选') {
              that.fieldValues.push([])
            } else {
              that.fieldValues.push('')
            }
          }
        }
      },
      formDataIsValid() {
        var isValid = true
        for (var i = 0; i < this.formFields.length; i++) {
          var field = this.formFields[i]

          var fName = field.field_name
          var fValue = this.fieldValues[i]
          var fType = field.field_type
          var fOptional = field.optional

          if (fOptional !== 1) {
            if (Utils.isEmpty(fValue)) {
              if (fType === '文本' || fType === '数字') {
                this.$message.error('请输入' + fName)
              } else if (fType === '日期') {
                this.$message.error('请选择' + fName)
              } else if (fType === '身份证号') {
                this.$message.error('请输入' + fName)
              } else if (fType === '手机号') {
                this.$message.error('请输入' + fName)
              } else if (fType === '车牌号') {
                this.$message.error('请输入' + fName)
              } else if (fType === 'Email邮箱') {
                this.$message.error('请输入' + fName)
              }

              isValid = false
              break
            }
          }
        }

        return isValid
      },
      loadSingleOptions(field_name) {
        var options = []

        for (var i = 0; i < this.field_options.length; i++) {
          var item = this.field_options[i]
          if (item.key === field_name) {
            options = item.values
          }
        }

        return options
      },
      loadMutiOptions(field_name) {
        var options = []

        for (var i = 0; i < this.field_options.length; i++) {
          var item = this.field_options[i]
          if (item.key === field_name) {
            var values = item.values

            for (var j = 0; j < values.length; j++) {
              var valueItem = values[j]
              options.push({
                label: valueItem,
                value: valueItem
              })
            }

            break
          }
        }

        return options
      },
      openQrcode() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在保存,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var eid = 'abc'
        var requestUrl = '/form/web/_qrcode_generator.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id,
              publish_username: eid,
              app_name: '多人填表'
            }
          }).then(function(response) {
            var qrcode_name = response.data.file_name
            console.log('>>>>>>>>>>>', qrcode_name)
            that.qrcode_image_url = '/form/' + qrcode_name

            that.scanQrcodeDialogVisible = true
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      }
    }

  }
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/user_form.vue